import { render, staticRenderFns } from "./FeederSystem.vue?vue&type=template&id=23682420"
import script from "./FeederSystem.vue?vue&type=script&lang=js"
export * from "./FeederSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports